import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import ActividadesAcademicasView from './ActividadesAcademicasView';
import * as ROUTES from '../../../router/Routes';

const ActividadesAcademicasModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.actividadesAcademicas}
      routes={[ROUTES.academico]}
    >
      <ActividadesAcademicasView />
    </ContainerTemplate>
  );
};

export default ActividadesAcademicasModule;
